import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { createUseStyles } from 'react-jss';
import { DetailsRow } from '../car_details_playback/details_row';
import { CarProgressBar } from './car_progress_bar';

const useStyles = createUseStyles((theme) => ({
    wrapper: {
        maxWidth: '720px',
        width: '100%'
    },
    container: {
        display: 'flex',
        marginBottom: '2rem'
    }
}));

export const CarJourneySummary = ({ percentageComplete }) => {
    const vehicle = useSelector((state) => state.getIn([
        'vertical', 'quote', 'prefillVerify', 'response', 'data', 'form', 'coverDetail', 'vehicle'
    ]));

    const { year, make, model } = vehicle?.toJS() || {};

    const classes = useStyles();

    return (
        <div className={classes.wrapper}>
            <DetailsRow
                year={year}
                make={make}
                model={model}
                body={null}
                fuel={null}
                className={classes.container}
            />
            <CarProgressBar
                percentageComplete={percentageComplete}
            />
        </div>
    );
};

CarJourneySummary.propTypes = {
    percentageComplete: PropTypes.number
};
